//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ButtonToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  }
};
